const _trApiTranslation = {
  api_unknown_err: "Bilinmeyen bir hata oluştu.",
};

export default _trApiTranslation;
